import { AnimatePresence, motion } from "framer-motion";

import { useTheme } from "../theme/ThemeContext";
import "./ThemeToggle.css";

/** Sun ⇄ moon. The icon swaps with a small turn; nothing else moves. */
export default function ThemeToggle({ tone = "dark" }: { tone?: "dark" | "light" }) {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      className={`theme-toggle theme-toggle-${tone}`}
      onClick={toggle}
      aria-label={dark ? "Light mode" : "Dark mode"}
      aria-pressed={dark}
      title={dark ? "Light" : "Dark"}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          className="theme-toggle-icon"
          initial={{ rotate: -60, opacity: 0, scale: 0.6 }}
          animate={{ rotate: 0, opacity: 1, scale: 1 }}
          exit={{ rotate: 60, opacity: 0, scale: 0.6 }}
          transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
        >
          {dark ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8" />
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />
            </svg>
          )}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
